import { create } from 'zustand';

const useLogoutIntentStore = create((set) => ({
  pendingPath: null,
  requestLogout: (path) => set({ pendingPath: path }),
  clearLogout: () => set({ pendingPath: null }),
}));

export default useLogoutIntentStore;
